import React from "react";
import { TransitionContainer } from "../styles/components/Global/Global.js";

const Transition = () => {
  return <TransitionContainer id="scene-transition" />;
};

export default Transition;
